/* src/app/ai-sourcing/ai-sourcing-profile-card/ai-sourcing-profile-card.component.scss */
.dstooltip {
  position: relative;
  display: inline-block;
}
.dstooltip-content {
  display: none;
  position: absolute;
  min-width: 360px;
  width: 360px;
  box-shadow: 0 4px 10px 0 rgba(46, 147, 161, 0.2);
  top: 18px;
  z-index: 1;
}
.dstooltip:hover .dstooltip-content {
  display: block;
}
.circular-img {
  width: 59px;
  height: 59px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  font-weight: 600;
  background-color: #F4F4F4;
}
.yellow-circle {
  background-color: #FFF9D7 !important;
  color: #E0BF00 !important;
}
.blue-circle {
  background-color: #B9D4F4;
  color: #1C5FB0;
}
.pink-circle {
  background-color: #FBDAE7;
  color: #A5124D;
}
.teal-circle {
  color: #34A853;
  background-color: #EBF6EE;
}
.highlight-pill {
  max-width: max-content;
  width: max-content;
  padding: 4px 8px;
  border-radius: 30px;
  align-items: center;
  margin-right: 0.6rem;
  margin-bottom: 5px;
  font-weight: 12px;
  cursor: pointer;
  font-weight: 600;
}
.highlight-pill-yellow {
  background-color: #fff8e7;
}
.highlight-pill-green {
  background-color: #e5fffa;
}
.highlight-pill-blue {
  background-color: #eef4ff;
}
.highlight-pill-teal {
  background-color: #e5faff;
}
.highlight-pill-red {
  background-color: #fff5f8;
}
.highlight-pill-unicorn {
  position: relative;
}
.highlight-pill-unicorn img {
  height: 20px;
  position: absolute;
  left: 8px;
  top: 3px;
}
.highlight-pill-unicorn span.dstooltip {
  margin-left: 15px;
}
.highlight-pill-pink {
  background-color: #fff5f8;
}
.highlight-pill-yearsofexp {
  background-color: #e5faff;
}
.highlight-pill-skills {
  background-color: #f6eaff;
}
.highlight-pill-locations {
  background-color: #f6eaff;
}
.highlight-pill-company {
  background-color: #ffefff;
}
.highlight-pill-title {
  background-color: #fff8e7;
}
.highlight-tooltip-content {
  display: none;
  position: absolute;
  top: 1.875rem;
  right: 0;
  background-color: #fff;
  min-width: 17.5rem;
  width: fit-content;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  z-index: 1;
  padding: 0.5rem 0;
}
.role-compatibility {
  height: 21px;
  font-family: Poppins;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #484b59;
}
.pills-container {
  max-width: 80%;
  min-width: 20rem;
  display: flex;
  align-items: center;
}
.highlight-tooltip-content {
  display: none;
  position: absolute;
  top: 1.875rem;
  right: 0;
  background-color: #fff;
  min-width: 17.5rem;
  width: fit-content;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  z-index: 1;
  padding: 0.5rem 0;
}
.dstooltip:hover .highlight-tooltip-content {
  display: block;
}
.hl-mssg {
  margin-left: 1.4rem;
  display: inline-block;
  padding: 0 8px;
  line-height: 1.5;
}
.dot {
  width: 4px;
  height: 4px;
  background-color: #484b59;
  border-radius: 50%;
  position: absolute;
  left: 19px;
  top: 8px;
}
.highlight-tooltip-content div {
  position: relative;
  margin-left: -5px;
}
.highlight-tooltip-divider {
  width: 90%;
  margin: 11px !important;
}
.fw-600 {
  font-weight: 600;
}
.highlight-top-container {
  margin: 8px !important;
}
.hiderule:last-child > hr {
  display: none;
}
.briefcase-blank {
  font-size: 14px;
  margin-right: 8px;
  cursor: default;
}
.briefcase-blank-yellow {
  color: #e9ac0d;
}
.briefcase-blank-green {
  color: #12bf9d;
}
.briefcase-blank-blue {
  color: #5385e7;
}
.briefcase-blank-teal {
  color: #1fa5c5;
}
.briefcase-blank-red {
  color: #e54f7a;
}
.btn-trms-small {
  background-color: #ffffff;
  color: #2e93a1;
}
.job-compalibility-summary {
  padding: 5px 12px;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  margin-bottom: 12px;
  background:
    linear-gradient(
      268deg,
      rgba(226, 78, 127, 0) 2.74%,
      rgba(226, 78, 127, 0.1) 98.26%);
  margin-left: -10px;
  margin-right: -10px;
}
.job-compalibility-summary .gen-ai-text {
  background:
    linear-gradient(
      267.38deg,
      #C845AB 15.14%,
      #E24E7F 52.19%);
  background-clip: text;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.7;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.job-compalibility-summary .gen-ai-text.text-9696 {
  background:
    linear-gradient(
      0deg,
      rgb(150, 150, 150) 0%,
      rgb(150, 150, 150) 100%);
  background-clip: text;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.7;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.job-compalibility-summary .potential-match-btn {
  color: #FBA744;
  background: rgba(251, 167, 68, 0.1411764706);
  border-radius: 16px;
  padding: 5px 10px;
  font-size: 12px;
  font-weight: 500;
}
.job-compalibility-summary .good-match-btn {
  color: #C5C955;
  background: #F7FAED;
  border-radius: 16px;
  padding: 5px 10px;
  font-size: 12px;
  font-weight: 500;
}
.job-compalibility-summary .excellent-match-btn {
  color: #229300;
  background: #E0F0DB;
  border-radius: 16px;
  padding: 5px 10px;
  font-size: 12px;
  font-weight: 500;
}
.job-compalibility-summary .notamatch-match-btn {
  color: rgba(205, 15, 15, 0.5490196078);
  background: #FAE7E7;
  border-radius: 16px;
  padding: 5px 10px;
  font-size: 12px;
  font-weight: 500;
}
.expandAll-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #969696;
  font-size: 12px;
  font-weight: normal;
  margin-bottom: 10px;
}
.expandAll-row .expandAll {
  color: #2e93a1;
  cursor: pointer;
}
.collapsible-section .collapsible-row {
  margin-bottom: 15px;
}
.collapsible-section .collapsible-row p {
  margin-bottom: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.collapsible-section .collapsible-row p a {
  color: #484b59;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.collapsible-section .collapsible-row p a span .fa-thumbs-up {
  color: #68AA86;
}
.collapsible-section .collapsible-row p a span i.fa-regular {
  font-size: 14px;
  color: rgba(46, 147, 161, 0.5019607843);
}
.collapsible-section .collapsible-row .collapse-description {
  color: #484b59;
  font-size: 14px;
  line-height: 1.5;
  font-weight: 400;
}
.lavender-circle {
  background-color: #E1D8E9 !important;
  color: #725190 !important;
}
.yellow-circle {
  background-color: #FFF9D7 !important;
  color: #E0BF00 !important;
}
.blue-circle {
  background-color: #B9D4F4;
  color: #1C5FB0;
}
.pink-circle {
  background-color: #FBDAE7;
  color: #A5124D;
}
.teal-circle {
  color: #34A853;
  background-color: #EBF6EE;
}
.more-ai-matched-card {
  border: 1px solid #9CD1FF;
  background:
    linear-gradient(
      90deg,
      rgba(108, 189, 255, 0.2) -1.65%,
      rgb(255, 255, 255) 80%);
  padding: 8px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.more-ai-matched-card p {
  font-size: 11px;
  font-weight: normal;
  line-height: 1;
  font-style: italic;
  color: #000000;
  margin-bottom: 0;
}
.more-ai-matched-card .btn-get-more-candidate {
  background-color: #F2F2F2;
  color: #969696;
  font-size: 14px;
  font-weight: 500;
  padding: 8px 8px;
  border: none;
  outline: none;
}
.more-ai-matched-card .btn-get-more-candidate:focus {
  outline: none;
}
.more-ai-matched-card .btn-get-more-candidate.active {
  background-color: #2e93a1;
  color: #ffffff;
}
.empty-card {
  border: 1px solid rgba(46, 147, 161, 0.3019607843);
  background:
    linear-gradient(
      183.08deg,
      rgba(163, 255, 226, 0.45) -58.69%,
      rgba(255, 255, 250, 0.45) 53.16%,
      rgba(255, 245, 134, 0.45) 164.33%);
  padding: 30px 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #484b59;
}
.empty-card div {
  width: 60%;
}
.empty-card span.text-center {
  display: flex;
  justify-content: center;
  font-size: 30px;
}
.empty-card p {
  text-align: center;
  line-height: 1.6;
}
.archive {
  color: rgba(205, 15, 15, 0.5411764706) !important;
  border-color: rgba(205, 15, 15, 0.5411764706) !important;
}
.wc-checkbox {
  width: 14px !important;
  height: 14px !important;
}
.wc-checkbox input[type=checkbox] {
  width: 14px !important;
  height: 14px !important;
}
.wc-checkbox input[type=checkbox]:checked ~ i {
  background-color: #2e93a1;
  border: 1px solid #2e93a1;
  transition: 0.5s;
}
.wc-checkbox i {
  width: 100%;
  height: 100%;
  background-color: #fff;
  color: #FFF;
  border: 1px solid #2e93a1;
  border-radius: 2px;
}
.companyHover {
  text-decoration: underline;
  text-decoration-style: dashed;
  text-decoration-color: #969696;
}
.companyHover {
  text-decoration: underline;
  text-decoration-style: dashed;
  text-decoration-color: #969696;
}
.dropbtn {
  background-color: #3498DB;
  color: white;
  padding: 16px;
  font-size: 16px;
  border: none;
}
.dstooltip {
  position: relative;
  display: inline-block;
}
.dstooltip-content {
  display: none;
  position: absolute;
  min-width: 360px;
  width: 360px;
  box-shadow: 0 4px 10px 0 rgba(46, 147, 161, 0.2);
  top: 18px;
  z-index: 1;
}
.dstooltip:hover .dstooltip-content {
  display: block;
}
.dropup:hover .dropbtn {
  background-color: #2980B9;
}
.dstooltip-content.source-div-style {
  position: absolute;
  right: 0;
  bottom: 30px;
  top: auto !important;
  box-shadow: none;
}
::-webkit-scrollbar {
  width: 4px;
}
:hover::-webkit-scrollbar {
  width: 4px;
  display: block;
  transition: all 0.4s;
}
::-webkit-scrollbar-track {
  background: white !important;
}
::-webkit-scrollbar-thumb {
  background: #CCCCCC;
}
::-webkit-scrollbar-thumb:hover {
  background: #CCCCCC;
}
.archive-modal {
  position: absolute;
  right: 50%;
  top: 100%;
  width: 500px;
  height: auto;
  background-color: #fff;
  z-index: 1;
  padding: 15px;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1019607843);
}
.criteria-btn-wrapper {
  position: relative;
  display: inline-block;
}
.match-criteria {
  position: absolute;
  top: 100%;
  left: -110px;
  background-color: #fff;
  min-width: 220px;
  width: fit-content;
  border-radius: 6px;
  border: 1px solid #d9d9d9;
  z-index: 1000;
  padding: 0.75rem;
  display: none;
  color: #484B59;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.criteria-btn:hover .match-criteria {
  display: block;
}
.text-excellent {
  color: #68AA86;
}
.text-good {
  color: #CBCE66;
}
.text-potential {
  color: #FBB057;
}
.text-danger {
  color: #E57F7F;
}
.gray-border-disabled {
  border-image-source:
    linear-gradient(
      0deg,
      rgb(217, 217, 217) 0%,
      rgb(217, 217, 217) 100%);
}
p a.showicon.text-9696 {
  color: #969696;
}
p a.showicon.text-9696 .fa-solid {
  color: #969696 !important;
}
.btn-re-run-screen {
  background:
    linear-gradient(
      180deg,
      rgba(200, 69, 171, 0.1) 0%,
      rgba(226, 78, 127, 0.1) 100%);
  border: 1px solid;
  border-image-source:
    linear-gradient(
      180deg,
      #C845AB 0%,
      #E24E7F 100%);
  border-image-slice: 1;
  padding: 6px 20px;
  font-weight: 600;
  font-size: 14px;
}
[class^=btn-trms-] {
  font-size: 12px !important;
  padding: 7px 14px !important;
}
.contactIcoBox {
  padding: 2px 8px;
  border-radius: 4px;
  background: rgba(150, 150, 150, 0.0784313725);
  color: #969696;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0px;
  margin-left: 10px;
  cursor: pointer;
}
.contactIcoBox .fa-pipe {
  color: rgba(150, 150, 150, 0.2509803922);
  margin-left: 8px;
  margin-right: 8px;
}
.contactIcoBox .fa-envelope {
  color: rgba(150, 150, 150, 0.5176470588);
  transition: all 0.5s ease-in-out;
}
.contactIcoBox .fa-envelope:hover {
  color: #797979;
}
.contactIcoBox .fa-phone {
  color: rgba(150, 150, 150, 0.5176470588);
  transition: all 0.5s ease-in-out;
}
.contactIcoBox .fa-phone:hover {
  color: #797979;
}
.shortlisted.contactIcoBox {
  background: rgba(46, 147, 161, 0.1019607843);
  color: #2e93a1;
}
.shortlisted.contactIcoBox .fa-pipe {
  color: rgba(46, 147, 161, 0.2509803922);
}
.shortlisted.contactIcoBox .fa-envelope {
  color: #2e93a1;
  transition: all 0.5s ease-in-out;
}
.shortlisted.contactIcoBox .fa-envelope:hover {
  color: #2e93a1;
}
.shortlisted.contactIcoBox .fa-phone {
  color: #2e93a1;
  transition: all 0.5s ease-in-out;
}
.shortlisted.contactIcoBox .fa-phone:hover {
  color: #2e93a1;
}
.contactIcoBox.shortlisted {
  background: rgba(46, 147, 161, 0.1019607843);
  color: #2e93a1;
}
.collapsible-section .card-row:last-child .collapsible-row {
  margin-bottom: 0;
}
.collapsible-section .card-row:last-child .collapsible-row p {
  margin-bottom: 0;
}
/*# sourceMappingURL=ai-sourcing-profile-card.component-H6JPQBZS.css.map */
